// extracted by mini-css-extract-plugin
export default {"label":"SimpleInputLabel_label__UYSQV"};